import { calculateEstimatedReadTime } from '@helpers/estimatedReadTime';
import { formatDate } from '@helpers/miscelleanous';
import parseHtml from '@lib/html-parser';
import { Link } from '@ui/atoms';

function BlogListItemContent({ item = {}, isFeaturedBlogContent = false, isRelatedBlog }) {
    const speed = calculateEstimatedReadTime(item?.content);
    const HeadingTag = isRelatedBlog ? 'h6' : 'h2';
    return (
        <>
         <div>
            <ul
                className={`skeleton-loader flex justify-between  text-gray-900 text-xs xl:text-sm  ${isFeaturedBlogContent
                        ? 'gap-8 md:justify-start'
                        : 'bg-gray-100 px-6 py-3'
                    } `}
            >
                <li
                    className={`${isFeaturedBlogContent ? '' : 'truncate w-40'
                        }`}
                >
                    {item.categories?.edges
                        .map((edge) => edge.node.name)
                        .join(',')}
                </li>
                <li className="">{item?.content && `${speed} min read`}</li>
            </ul>

        <HeadingTag
            className={`font-semibold line-clamp-2 ${
                    isFeaturedBlogContent
                    ? 'mt-3 xl:mt-5 md:text-lg lg:text-xl xl:text-2xl'
                        : 'mt-2 px-6 xl:text-xl bg-[white]'
            } skeleton-loader`}
        >
            {item.slug ? (
                 <Link href={`/blogs/${item.slug}`}>
                    {item.title}
                </Link>
            ) : (
                item.title
            )}
        </HeadingTag>

            <div
                className={`mt-2 xl:mt-4 line-clamp-4 ${isFeaturedBlogContent
                        ? 'text-xs lg:text-sm xl:text-lg'
                        : 'text-xs lg:text-sm xl:text-base px-6 bg-[white]'
                    } text-gray-600 skeleton-loader`}
            >
                {parseHtml(item.excerpt)}
            </div>
            {item.excerpt && (
                <div
                    className={`${isFeaturedBlogContent
                            ? 'text-xs lg:text-sm xl:text-lg'
                            : 'text-xs lg:text-sm xl:text-base px-6 bg-[white]'
                        } text-primary-500 font-semibold skeleton-loader`}
                >
                    <Link
                        href={`/blogs/${item.slug}`}
                        className="cursor-pointer"
                    >{`Read More >`}</Link>
                </div>
            )}
        </div>
            <footer
                className={`mt-5 flex font-semibold ${!isFeaturedBlogContent
                        ? 'px-6 pb-6 gap-1 justify-between'
                        : 'gap-2 justify-between md:justify-start'
                    } items-center`}
            >
                {item.date ? (
                    <>
                        <div className="text-xs xl:text-sm text-gray-600 skeleton-loader capitalize">
                            {item?.author?.node?.name}
                        </div>
                        {isFeaturedBlogContent && (
                            <div className="hidden md:block text-xs xl:text-sm text-gray-600 skeleton-loader">
                                |
                            </div>
                        )}

                        <time
                            className="text-xs xl:text-sm text-gray-600 skeleton-loader"
                            dateTime={item.date}
                        >
                            {formatDate(item.date)}
                        </time>
                    </>
                ) : (
                    <span className="w-1/2"></span>
                )}
            </footer>
        </>
    );
}

export default BlogListItemContent;
